import $ from "jquery/dist/jquery";

/**
 * Static form that sends the visitor on to a checkout URL once the submit went
 * through — the second step of the "Start free trial" flow (register the
 * practice, then buy the NFC cards).
 *
 * Same contract as .ajaxStaticForm from @nxcms/nxcms-js, plus:
 *   data-checkout-url    where to send the visitor after a successful submit
 *                        (empty = stay on the success message)
 *   data-checkout-delay  ms to keep the success message visible first
 *
 * The success block may hold a [data-checkout-link] anchor, which is pointed
 * at the same URL so the visitor is never stuck if the automatic redirect is
 * blocked, and a [data-checkout-countdown] element ticking the seconds down —
 * purely visual (aria-hidden in the template), so it isn't re-announced every
 * second by the success block's aria-live region.
 */
$(() => {
  $(document).on("submit", ".ajaxStaticFormRedirect", (e) => {
    e.preventDefault();

    const form = $(e.currentTarget);
    const errorEl = $(form.attr("data-error-target"));
    const successEl = $(form.attr("data-success-target"));
    const gaEvent = form.attr("data-ga-event-name");
    const showTimeout = parseInt(form.attr("data-success-show-timeout"), 10) || 3000;
    const checkoutUrl = form.attr("data-checkout-url");
    const checkoutDelay = parseInt(form.attr("data-checkout-delay"), 10) || 4000;

    form.hide("fast");
    successEl.hide("fast");
    errorEl.hide("fast");

    $.ajax({
      type: form.attr("method"),
      url: form.attr("action"),
      data: form.serialize(),
    })
      .done(() => {
        if (gaEvent) {
          window.gtag?.("event", gaEvent);
        }
        successEl.show("fast");

        if (checkoutUrl) {
          successEl.find("[data-checkout-link]").attr("href", checkoutUrl);

          const countdownEl = successEl.find("[data-checkout-countdown]");
          let secondsLeft = Math.max(Math.round(checkoutDelay / 1000), 1);
          countdownEl.text(secondsLeft);

          const tick = window.setInterval(() => {
            secondsLeft -= 1;
            if (secondsLeft <= 0) {
              window.clearInterval(tick);
              window.location.assign(checkoutUrl);
              return;
            }
            countdownEl.text(secondsLeft);
          }, 1000);
          return;
        }

        // No checkout URL configured yet — behave like the plain static form.
        successEl.find("[data-checkout-link]").hide();
        window.setTimeout(() => {
          successEl.hide("fast");
          form[0].reset();
          form.show("fast");
        }, showTimeout);
      })
      .fail(() => {
        successEl.hide("fast");
        form.show("fast");
        errorEl.show("fast");
      });
  });
});
